'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagDzAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 1.30606e-05C9.33333 -7.95096e-05 18.6667 4.17947e-06 28 4.17947e-06C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20V1.30606e-05Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H14.6667V4.17947e-06L0 1.30606e-05V20Z",
          fill: "#048345"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.3333 11.04L15.7659 12.1574L16.3442 10.3214L14.7972 9.17596L16.722 9.15863L17.3333 7.33334L17.9446 9.15863L19.8695 9.17596L18.3224 10.3214L18.9008 12.1574L17.3333 11.04Z",
          fill: "#E81B42"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.68 14.3813C16.6519 15.3853 15.2702 16 13.7509 16C10.5748 16 8 13.3137 8 10C8 6.6863 10.5748 4 13.7509 4C15.2702 4 16.6519 4.61468 17.68 5.61867C16.9709 5.28113 16.1688 5.09091 15.3193 5.09091C12.4319 5.09091 10.0912 7.28879 10.0912 10C10.0912 12.7112 12.4319 14.9091 15.3193 14.9091C16.1688 14.9091 16.9709 14.7189 17.68 14.3813Z",
          fill: "#E81B42"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M27.5 0.499974L14.6689 0.499973V-2.75036e-05L28 4.17947e-06V20L14.6689 20V19.5L27.5 19.5V0.499974Z",
          fill: "#949494"
        }
      )
    ]
  }
);
const VpFlagDzAsset = forwardRef(FlagDzAsset);

export { VpFlagDzAsset as default };
